import OriginTracer from '@atlassiansox/origin-tracing/origin-tracer';

// Only Billing Preview adds an explicit source org; EA/Jira retain their existing click tracing.
// Keep this capture scoped to the Billing Preview URL contract.
export const getBillingPreviewSubmissionContext = (
	search: string,
): Record<string, string | boolean> => {
	const params = new URLSearchParams(search);
	const orgIds = params.getAll('pls_org_id');
	const orgId = orgIds[0];
	if (
		params.getAll('pls_source').length !== 1 ||
		params.get('pls_source') !== 'adminhub-billing-preview' ||
		orgIds.length !== 1 ||
		!orgId ||
		!/^[\da-f]{8}(?:-[\da-f]{4}){3}-[\da-f]{12}$/i.test(orgId)
	) {
		return {};
	}

	const origins = params.getAll('atlOrigin');
	const origin = OriginTracer.fromEncoded(origins.length === 1 ? (origins[0] ?? null) : null);
	return {
		pls_org_id: orgId,
		...(origin.isValid() && origin.product === 'admin' ? origin.toAnalyticsAttributes() : {}),
	};
};
